import React from 'react';
import PropTypes from 'prop-types';

import SrFormikField, {
  SR_FIELD_THEME_ADOBE,
} from 'client/components/SrFormikField';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrSunSetupDriverJobPage.less';

const SrSunSetupDriverJobCodeboxSpecialInstructions = ({
  formikBag,
  getFormFieldsById,
}) => {
  return (
    <div styleName='card'>
      <span styleName='cardTitle'>
        Special Instructions (Optional)
      </span>

      <SrBox paddingTop='8px'>
        <SrText
          font='greycliff'
          fontSize='14px'
          weight='500'
          lineHeight='20px'
        >
          If the Codebox is hard to find. Please provide instructions on how
          to find the Codebox.
        </SrText>
        <SrText
          font='greycliff'
          fontSize='14px'
          weight='800'
          lineHeight='20px'
        >
          &nbsp;These will be displayed to the renter&nbsp;
        </SrText>
        <SrText
          font='greycliff'
          fontSize='14px'
          weight='500'
          lineHeight='20px'
        >
          when they tour the home.
        </SrText>
      </SrBox>

      <div styleName='card'>
        <SrFormikField
          formField={getFormFieldsById('codeboxInstructions')}
          formikBag={formikBag}
          theme={SR_FIELD_THEME_ADOBE}
        />
      </div>
    </div>
  );
};

SrSunSetupDriverJobCodeboxSpecialInstructions.propTypes = {
  formikBag: PropTypes.object.isRequired,
  getFormFieldsById: PropTypes.func.isRequired,
};

SrSunSetupDriverJobCodeboxSpecialInstructions.displayName = 'SrSunSetupDriverJobCodeboxSpecialInstructions';

export default SrSunSetupDriverJobCodeboxSpecialInstructions;
